import React from "react";
import { Badge } from "@/components/ui/badge";
import { STATUS_VARIANT } from "@/constants";

export function StatusBadge({ status }) {
  const cls = STATUS_VARIANT[status] || "bg-muted/40 text-muted-foreground border border-border";
  return (
    <Badge data-testid="ot-status-badge" className={`rounded-md font-medium ${cls}`} variant="outline">
      {status}
    </Badge>
  );
}
